import ResultsStore from "@/store/results";
import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";
import Team from "./team";

export default interface Answer {
  id: string;
  taskId: string;
  teamId: string;
  team: Team;
  timeToAnswer?: number; // time taken to answer in seconds
  correct?: boolean;
  score?: number; // how this answer changed score
  outOfTime?: boolean;
  hintUsed?: boolean;

  // answer fields depend on question type
  text?: string; // if "text" type
  value?: number; // if "number" type
  option?: number; // if "single" type (selected option index counting from 0)
  options?: number[]; // if "multiple" type (selected option indices counting from 0)
  asString?: string;

  // if "objectFinder" type
  // top, left, bottom, right, score
  // (coordinates relative to image size and model score)
  detection?: number[];

  // if uploading photo or video related to this task, then enter medium id here
  // currently this is the same as taskId
  medium?: string;
}

export class AnswerConverter implements FirestoreDataConverter<Answer> {
  constructor(private results: ResultsStore) {}

  toFirestore(answer: Answer): DocumentData {
    return answer;
  }

  fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions): Answer {
    const answer = { id: snapshot.id, ...snapshot.data(options) } as Answer;
    const task = this.results.game.tasks.find(task => task.id === answer.taskId);

    answer.team = this.results.teamsById[answer.teamId];

    switch (task?.answerType) {
      case "text":
        answer.asString = answer.text || "";
        break;
      case "number":
      case "number:range":
        if (answer.value !== undefined) {
          answer.asString = answer.value + "";
        }
        break;
      case "single":
        if (answer.option !== undefined) {
          answer.asString = task.answers[answer.option]?.text;
        }
        break;
      case "multiple":
        if (answer.options !== undefined) {
          answer.asString = answer.options.map(option => task.answers[option]?.text).join(", ");
        }
        break;
    }

    return Object.freeze(answer);
  }
}
